export * from './lib/deheading-sample-test-print';
